import {
  saveInvite,
  getFocusList,
  getStyleList,
  getInviteInfo,
  saveInviteStatus,
  getPreference,
  preferenceList,
  getSelectFieldOption,
  getHouseStatusList,
  getSpaceList,
  getMembers,
  getEvaluating,
  getInterests
} from '@/api/rad1'

const state = {
}

const mutations = {
}

const actions = {
// (rad1)-02-提交评测
  saveInvite({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      saveInvite(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // (rad1)-04-装修关注点列表
  getFocusList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getFocusList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // (rad1)-05-装修风格类型列表
  getStyleList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getStyleList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // (rad1)-06-邀请涵详情
  getInviteInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getInviteInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // (rad1)-01-修改邀请函状态
  saveInviteStatus({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      saveInviteStatus(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // STEP01-0202-风格探索
  getPreference({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getPreference(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // STEP01-0201-(风格偏好)列表
  preferenceList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      preferenceList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 04-获取选项字段选择下拉列表
  getSelectFieldOption({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getSelectFieldOption(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 交房状态
  getHouseStatusList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getHouseStatusList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getSpaceList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getSpaceList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getMembers(temp, data) {
    return new Promise((resolve, reject) => {
      getMembers(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getEvaluating(temp, data) {
    return new Promise((resolve, reject) => {
      getEvaluating(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // designer-04-获取成员兴趣爱好
  getInterests(temp, data) {
    return new Promise((resolve, reject) => {
      getInterests(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
